import { render, staticRenderFns } from "./SingleProcess.vue?vue&type=template&id=13d7242a&"
import script from "./SingleProcess.vue?vue&type=script&lang=js&"
export * from "./SingleProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports